/**
 * @generated SignedSource<<8aafc2ad26ed0784e6211234b9ba9d11>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetails_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ContactDealerInlineForm_viewer" | "PdpSharedDealerDetailsHeader_viewer" | "PdpSharedDealerInfo_viewer" | "PdpSharedSellerDetailsReviewContainer_viewer" | "PdpSharedSellerTabsVariant_viewer">;
  readonly " $fragmentType": "PdpRespDealerDetails_viewer";
};
export type PdpRespDealerDetails_viewer$key = {
  readonly " $data"?: PdpRespDealerDetails_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerDetails_viewer",
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContactDealerInlineForm_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerDetailsReviewContainer_viewer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsHeader_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerInfo_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2e919d8cda7906bfdc34e780cf6d20f4";

export default node;
